<template>
  <v-card
    max-width="100%"
    max-height="100%"
    variant="elevated"
    class="border"
    style="max-height: 100%; max-width: 100%; margin: 80px 500px; padding: 20px 0px 70px 0px;"
    elevation="24"
  >
    <v-card-text>
      <h2 class="d-flex justify-center">Logging You In...</h2>
      <br>
      <v-row no-gutters class="d-flex justify-center">
        <v-progress-circular
          class="my-2"
          indeterminate
          :size="50"
          :width="4"
          color="primary"
        >
          <v-col>
            <img src="../../assets/logo1.svg" width="20" alt="logo">
          </v-col>
        </v-progress-circular>
      </v-row>
      <br><br>
      <p class="d-flex text-center justify-center">
        We're now verifying your request and securely logging you into your account.
        <br>
        This process may take a few seconds. Please do not close this page or hit the back button.
        <br>
        Once the verification is complete, you'll be redirected automatically.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
import jwtDecode from "jwt-decode";

export default {
  name: "VerifyLoginPage",
  mounted() {
    const q = this.$route.query.q;
    if (!q) {
      console.error("Query parameter 'q' tidak ditemukan");
      return;
    }

    try {
      const jwtDecoded = jwtDecode(q);
      const cid = localStorage.getItem("cid");

      const payload = {
        cid: cid,
        user_id: jwtDecoded.user_id,
        code: jwtDecoded.code,
        url_validation: jwtDecoded.url_validation
      };

      this.$store.dispatch("auth/doVerifyEmailAuth", payload);
    } catch (err) {
      console.error("Gagal decode JWT:", err);
    }
  }
};
</script>
